import { LIMIT } from '@/constants';
import { fetcher } from '@/services/graphql/fetcher/index';
import { Sort, type AnyObj } from '@/types';
import {
  fetchAvailableOrdersToReviewDocument,
  fetchCreateReviewProductDocument,
  fetchReviewsByProductIdDocument,
  fetchReviewsProductDocument,
} from '../graphql/docs';

/**
 * 获取待评论列表
 * @param skip - 数据略过个数
 */
export const fetchWaitCommentList = async (skip: number) => {
  const res = await fetcher.query(fetchAvailableOrdersToReviewDocument, {
    variables: {
      options: {
        take: LIMIT,
        skip: LIMIT * skip,
        sort: {
          createdAt: Sort.DESC,
        },
      },
    },
  });
  return res.data.value?.availableOrdersToReview?.items;
};

/**
 * 获取已评论列表
 * @param skip - 数据略过个数
 */
export const fetchYetCommentList = async (skip: number) => {
  const res = await fetcher.query(fetchReviewsProductDocument, {
    variables: {
      options: {
        take: LIMIT,
        skip: LIMIT * skip,
        sort: {
          createdAt: Sort.DESC,
        },
      },
    },
  });
  return res.data.value.myReviewsProduct.items;
};

/**
 * 创建评价
 * @param input
 */
export const fetchCreateComment = async (input: AnyObj) => {
  const res = await fetcher.mutation(fetchCreateReviewProductDocument, { input });
  return res.data?.createReviewProduct;
};

/**
 * 根据商品id获取评论数据
 * @param variables
 */
export const fetchReviewsByProductId = async (variables: AnyObj) => {
  const res = await fetcher.query(fetchReviewsByProductIdDocument, {
    variables,
  });
  return res.data.value?.reviews;
};
